import { render } from "./FormCargoComponent.vue?vue&type=template&id=92dadd00"
import script from "./FormCargoComponent.vue?vue&type=script&lang=js"
export * from "./FormCargoComponent.vue?vue&type=script&lang=js"

import "./FormCargoComponent.vue?vue&type=style&index=0&id=92dadd00&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__